import React from "react";
// Zustand
import { useStore } from "../../zustand";
// Core Components
// import ViewSpaceBtn from '../ButtonsUI/ViewSpaceBtn';
// import BtnLaunchAR from '../ButtonsUI/BtnLaunchAR';
//import CartBtn from '../ButtonsUI/CartBtn'; TO DO
import BillboardTabs from '../BillboardUI/BillboardTabs';
// import ARLaunch from '../ButtonsUI/ARLaunch';
import CartBtn from '../ButtonsUI/CartBtn';
//import BillboardsPagination from './BillboardsPagination';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);


export default function BillboardSideBar() {
    const [state, setState] = React.useState({ ready: false });
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore.getState().variant_id;
    //const { intent } = useStore.getState().hrx;
    const { active_board, active_tab } = useStore(state => state.scene_controls);
    //const { addToCartBtn } = useStore.getState().settings; TO DO
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const { addToCartBtn } = useStore.getState().settings;
    const video_desc = useStore.getState().video_desc;
    const spec_sheet = useStore.getState().spec_sheet;
    const { h1, p } = vList[variant_id].billboard_list[active_board].info;
    const classes = useStyles(dynamic_text_settings);

    React.useEffect(() => {
        if(vList[variant_id]?.billboard_list[active_board]) {
            setState(state => ({
                ...vList[variant_id].billboard_list[active_board].info, 
                ready: true,
            }));
        }
        return () => {}
    }, [vList, variant_id, active_board]);

    // const _handleTabSelect = (targetTab) => {
    //     //setState({ tab: targetTab }) // Update tab state
    //     useStore.setState(state => ({ 
    //         scene_controls: { 
    //             ...state.scene_controls,
    //             active_tab: targetTab
    //         }
    //     }));
    //     return false;
    // }
    
    if(!state.ready) return null
    
    return (
        <div className={classes.billboard_sidebar}>
            {vList[variant_id].title && <h1 className={classes.variant_title}>{vList[variant_id].title}</h1> }
            {/*{ vList[variant_id].price && <span className={classes.variant_price}>${vList[variant_id].price}</span> }*/}
            <div className={classes.billboard_buttons}>
                {vList[variant_id].options.length < 2 &&
                    <div className={classes.image_container_focus} id="image_container_focus" style={{ backgroundImage: `url(${vList[variant_id].billboard_list[active_board].info.image_1.src})` }} />
                }
                <div className={classes.buttons_wrapper}>
                    {/*{ addToCartBtn && <CartBtn type="billboard" /> } TO DO*/}
                    { addToCartBtn && <CartBtn type="billboard" /> }
                    {/*<ARLaunch design="billboard" />*/}
                    {/* { ((intent === 'willQL') || (intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV')) &&
                        <BtnLaunchAR />
                    }
                    { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === "cant")) &&
                        <ViewSpaceBtn design="billboard" /> 
                    } */}
                </div>
            </div>
            <BillboardTabs tab={active_tab} h1={h1.text} text={p.text} device="desktop" description={video_desc} spec={spec_sheet} />
        </div>
    );
}